import {ProductPropertiesPane} from '../components/NodePropertiesPane.jsx'
import LongText from '../../SidePanel/RightPanel/PropertiesControllerLongText.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Analyse from '../components/PropertiesControllerAnalyse.jsx'
import Db from '../DB/PropertiesControllerDb.jsx'
import Dm from '../DM/PropertiesControllerDm.jsx'
import Model from './ModelDt.mjs'

const PropertiesPaneDt = (props) => (
    <ProductPropertiesPane
        controllers={
            <>
                <Db />
                <Dm />
                <Text prop="dtUserCode" />
                <Text prop="dtName" />
                <Text prop="dtAlias" />
                <LongText prop="dtDesc" />
                <LongText prop="memo" />
            </>
        }

        Model={Model}

        snSuffix={
            <Analyse
                modes={[
                    'ApiEffect',
                    'ChgReferenceSingle',
                    'Effect',
                    'FkDepend',
                    'FkEffect',
                    'Reference',
                    'ReferenceCall',
                    'IsrfReference',
                ]}
            />
        }

        {...props}
    />
)

export default PropertiesPaneDt
